module.exports = __webpack_public_path__ + "static/img/bb.cf766d48.png";